export const LIGHTBOX_TPA_PAGE_ID = {
  followingFollowers: 'following_followers_lightbox',
} as const;
